/* 승인된 회상 영상. 음성·자막·선택지는 기존 재생기가 맡는다. */
window.BGMEMORY = (() => {
  const FX = "/app/media/review/1004/baek-c07-memory/";
  // 10/9 느린 통신 — 전환 그림 여섯 장이 PNG 6.2MB 였다(느린 4G 에서 첫 그림이 37초). 같은 그림의 webp(1.4MB · 심리 테스트 연무와 같은 파일 — 10/8 바이트 대조)로
  const MW = "/app/media/psych-tests/releases/57935627c5f7/shared/", MIST = {
    "entry-fog": MW + "mist-entry-fog-v9-beb649f4987d.webp", "entry-mask": MW + "mist-entry-mask-v9-181a9ffe316c.webp",
    "return-fog": MW + "mist-return-fog-v9-55c8d9697844.webp", "return-mask": MW + "mist-return-mask-v9-07187d534f98.webp",
    "bridge-fog": MW + "mist-bridge-fog-v10-c5c417cdee07.webp", "bridge-mask": MW + "mist-bridge-mask-v10-53fd87e93998.webp",
  };
  const reduced = matchMedia("(prefers-reduced-motion: reduce)"), videos = new Map(), held = new Set();
  let stage, layer, canvas, mist, sound, questions = [], scenes, prepared, prepare, current, index = -1, active = false, hidden = false;
  let hiddenAt = 0, hiddenTime = 0;
  let woken = false;
  function watchStall(fail, limit = 8000) {
    let progress = performance.now();
    const timer = setInterval(() => {
      if (hidden) { progress = performance.now(); return; }
      if (performance.now() - progress >= limit) { const error = Error("회상 자료 준비가 중단됐어요"); error.code = "MEMORY_STALLED"; fail(error); }
    }, 250);
    return { progress() { progress = performance.now(); }, stop() { clearInterval(timer); } };
  }
  // 목록 · 전환 그림은 통신이 끊기면 여덟 번까지 다시 받는다. 그래도 안 되면 장면을 건너뛰고 무비는 이어 간다. 서버가 없다고 답할 때(4xx)는 바로 실패
  async function resource(url, priority = "auto") {
    for (let attempt = 0; attempt < 8; attempt++) {
      const controller = new AbortController(), watch = watchStall(() => controller.abort(), 12000);
      try {
        // 다시 받을 때는 캐시를 새로 — 같은 주소를 no-cors(new Image)로 먼저 받아 1년 캐시된 응답은 CORS fetch 에서 계속 실패한다
        const response = await fetch(url, { cache: attempt ? "reload" : "force-cache", signal: controller.signal, priority });
        if (response.status >= 400 && response.status < 500) { const error = Error("회상 자료 없음 " + response.status); error.code = "MEMORY_MISSING"; throw error; }
        if (!response.ok) throw Error("회상 자료 다운로드 오류");
        watch.progress();
        const reader = response.body.getReader(), parts = [];
        for (;;) { const { done, value } = await reader.read(); if (done) break; parts.push(value); watch.progress(); }
        return new Blob(parts, { type: response.headers.get("content-type") || "application/octet-stream" });
      } catch (error) { controller.abort(); if (error?.code === "MEMORY_MISSING") throw error; await new Promise(resolve => setTimeout(resolve, Math.min(4000, 500 * (attempt + 1)))); }
      finally { watch.stop(); }
    }
    const error = Error("회상 자료 준비 실패"); error.code = "MEMORY_STALLED"; throw error;
  }
  // 10/8 — 회상 영상은 장면당 5~7MB 를 통째로 받은 뒤에야 틀었고, 받는 중 12초 진행이 없으면 끊고 실패로 쳤다(느린 통신 · 무비 영상과 다투는 동안 장면이 빠진 까닭).
  //   무비 대사 영상처럼 주소를 바로 걸어 흘려 받으며 튼다(서버는 범위 요청 · 1년 캐시)
  function attach(v, key) {
    if (scenes?.[key] && v.dataset.memorySrc !== scenes[key]) { v.dataset.memorySrc = scenes[key]; v.src = scenes[key]; v.load(); }
    return Promise.resolve();
  }
  // 지금 장면과 다음 장면만 받는다 — 처음 누를 때 네 장면을 한꺼번에 받으면 첫 장면이 늦었다(느린 통신 9.4초). 나머지는 앞 장면이 나올 때 하나씩(next)
  function warm() {
    if (!scenes) return;
    const at = Math.max(0, index);
    questions.slice(at, at + 2).forEach(q => attach(video(q.q), q.q));
  }
  async function required(action, retry = () => {}, loading = false) {
    // 10/7 번체 중국어 — 중국어는 지역까지 본다(i18n.js 가 html lang 을 zh-TW · zh-HK 로 둔다)
    const lang = document.documentElement?.lang || "ko";
    // 10/8 — 기다리는 동안은 밤과비 로딩과 함께
    const text = ({ en: ["Loading the scene"], ja: ["シーンを読み込んでいます"], "zh-TW": ["正在載入場景"], "zh-HK": ["正在載入場景"] })[/^zh-/.test(lang) ? lang : lang.split("-")[0]] || ["장면을 불러오고 있어요"];
    let recovered = false;
    for (;;) {
      const notice = document.createElement("div");
      notice.setAttribute("role", "status");
      notice.style.cssText = "position:absolute;inset:0;z-index:8;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;background:rgba(0,0,0,.5);color:white;font-family:var(--font,sans-serif);font-size:var(--t-callout,16px);text-align:center;padding:24px";
      const ring = document.createElement("i"); ring.className = "lw-mini"; ring.setAttribute("aria-hidden", "true");   // 10/23 밤과비 로딩(play.html 이 싣는 logo-wait.js)
      const say = document.createElement("span"); say.textContent = text[0]; notice.append(ring, say);
      const timer = loading ? setTimeout(() => stage.appendChild(notice), 300) : null;
      try { return await action(); }
      catch (error) {
        if (error?.code === "MEMORY_STALLED" && !recovered) { recovered = true; retry(); continue; }
        // 10/8 감시 점검 — 예전에는 「장면을 불러오지 못했어요 · 다시 시도」에서 무비를 멈췄다(장면이 빠진 질문은 영영 못 넘어감 · 아이폰 저전력 모드).
        //   회상 장면은 꾸밈이라 못 받으면 부르는 쪽(enter · next · leave)이 장면 없이 무비를 이어 간다
        throw error;
      } finally { clearTimeout(timer); notice.remove(); }
    }
  }
  function visible() {
    if (!hidden) return Promise.resolve();
    return new Promise(resolve => {
      const resume = () => { if (!hidden) { document.removeEventListener("visibilitychange", resume); removeEventListener("pageshow", resume); resolve(); } };
      document.addEventListener("visibilitychange", resume); addEventListener("pageshow", resume);
    });
  }
  function slot() {
    const v = document.createElement("video");
    v.crossOrigin = "anonymous";   // 토스 웹뷰는 다른 출처라, 이 속성이 없으면 회상 영상을 캔버스에 못 그려 장면이 빠진다
    v.muted = v.defaultMuted = true; v.playsInline = true; v.setAttribute("playsinline", ""); v.loop = true; v.preload = "auto";
    return v;
  }
  // 10/20 — 회상 영상 칸은 손님이 누르기 전에(자료가 오기 전에도) 미리 만들어 둔다. 자료가 오기 전에 「시작」을 누른 손님(09-boot 미리)도 그 누름 안에서 칸을 풀게(unlock) —
  //   예전엔 칸을 자료가 온 뒤 setup 에서 만들어, 일찍 누른 길에서는 누름 밖에서 처음 틀었다(아이폰 저전력 모드 · 앱 안 브라우저면 막힘). 질문마다 회상 장면은 넷(data/*.json flow.questions), 더 많으면 나머지는 그때 만든다
  const slots = Array.from({ length: 4 }, () => slot());
  function video(key) {
    if (videos.has(key)) return videos.get(key);
    const v = slots.shift() || slot();
    layer.insertBefore(v, canvas); videos.set(key, v);
    if (woken) attach(v, key).catch(() => {});
    return v;
  }
  async function moving(v) {
    await visible();
    let playbackError;
    const own = [...videos.values()].includes(v);
    const kick = () => { if (own) v.play().catch(error => { if (error?.name === "NotAllowedError") playbackError = error; }); };
    if (own) {
      const key = [...videos].find(([, item]) => item === v)[0];
      await attach(v, key);
      kick();
    }
    await new Promise((resolve, reject) => {
      const start = v.currentTime;
      let stopped = false, still = performance.now(), reloaded = 0, reloads = 0, buffered = -1;
      const finish = error => { stopped = true; watch?.stop(); if (error) reject(error); else resolve(); };
      // 회상 영상은 멈춰도 포기하지 않는다 — 8초 동안 그대로이거나 받다 끊기면(오류) 다시 걸어 이어 받는다.
      // 10/20 — 무비 영상(돌아갈 끝인사)은 무대가 받고 다시 걸며, 다 받은 뒤에 튼다(02-stage play · full). 고정 8초로 보던 감시는 느린 통신에서 받는 중인 끝인사를 실패로 쳤다 —
      //   받기가 늘면 기다리고, 8초 동안 받기도 재생도 늘지 않거나 오류일 때만 장면을 걷는다
      const watch = own ? null : watchStall(finish);
      const draw = () => {
        if (stopped) return;
        if (playbackError) { finish(playbackError); return; }
        if (!own && v.error) { finish(Error("회상 영상 오류")); return; }
        if (!hidden && !v.paused && v.readyState >= 2 && v.videoWidth > 0 && Math.abs(v.currentTime - start) > .001) { finish(); return; }
        const now = performance.now();
        const end = v.buffered.length ? v.buffered.end(v.buffered.length - 1) : buffered;
        if (end !== buffered) { buffered = end; still = now; watch?.progress(); }
        if (hidden) still = now;
        else if (own && ((v.error && now - reloaded > 2000) || now - still > 8000)) {
          if (reloads >= 4) { finish(Error("회상 영상 오류")); return; }
          reloads++; still = reloaded = now; v.load(); kick();
        }
        requestAnimationFrame(draw);
      };
      requestAnimationFrame(draw);
    });
  }
  function renderer() {
    canvas.width = 360; canvas.height = 640;
    const paint = canvas.getContext("2d", { alpha: false }), w = canvas.width, h = canvas.height;
    const scene = document.createElement("canvas"); scene.width = w; scene.height = h;
    const sp = scene.getContext("2d"), images = {};
    const ready = Promise.all(["entry", "return", "bridge"].flatMap(key => ["mask", "fog"].map(kind => new Promise((resolve, reject) => {
      resource(MIST[key + "-" + kind], "low").then(blob => {
        const image = new Image(), url = URL.createObjectURL(blob);
        const clean = () => { watch.stop(); URL.revokeObjectURL(url); image.onload = image.onerror = null; };
        const watch = watchStall(error => { clean(); image.src = ""; reject(error); });
        image.onload = () => { clean(); images[key + "-" + kind] = image; resolve(); }; image.onerror = error => { clean(); reject(error); };
        image.src = url;
      }).catch(reject);
    }))));
    const zoom = (ctx, v, factor, cx, cy) => ctx.drawImage(v, (1 - factor) * cx * w, (1 - factor) * cy * h, w * factor, h * factor);
    function draw(from, to, p, returning, between) {
      paint.globalAlpha = 1; paint.globalCompositeOperation = "source-over";
      if (p <= 0 || p >= 1) { canvas.style.filter = "none"; canvas.style.transform = "none"; paint.drawImage(p <= 0 ? from : to, 0, 0, w, h); return; }
      const key = between ? "bridge" : returning ? "return" : "entry", count = between ? 24 : returning ? 30 : 36, n = Math.round(p * (count - 1));
      const envelope = Math.pow(Math.sin(Math.PI * p), 1.1), depth = between ? .025 : returning ? .07 : .16, overscan = 1 + .08 * envelope;
      paint.drawImage(from, 0, 0, w, h); zoom(paint, from, (1 + depth * envelope) / overscan, .53, .5);
      sp.globalCompositeOperation = "source-over"; sp.clearRect(0, 0, w, h); sp.drawImage(to, 0, 0, w, h); zoom(sp, to, (1 + depth * .55 * envelope) / overscan, .55, .48);
      sp.globalCompositeOperation = "destination-in"; sp.drawImage(images[key + "-mask"], n % 6 * 192, Math.floor(n / 6) * 288, 192, 288, 0, 0, w, h);
      paint.drawImage(scene, 0, 0); paint.drawImage(images[key + "-fog"], n % 6 * 192, Math.floor(n / 6) * 288, 192, 288, 0, 0, w, h);
      canvas.style.transform = `scale(${overscan})`; canvas.style.filter = `blur(${(between ? 6 : 14) * (canvas.clientWidth || w) / 1176 * envelope}px)`;
    }
    return { ready, draw };
  }
  function effect(key, duration) {
    const peak = key === "bridge" ? .3827291667 : key === "entry" ? .4261458333 : .1698125;
    const amplitude = key === "bridge" ? .7032775879 : key === "entry" ? 1 : .9742736816;
    const level = Math.pow(10, (key === "bridge" ? -24 : -14) / 20) / amplitude;
    const playing = sound?.play("memory-" + key, { delay: duration * .5 - peak, level: level * (key === "return" ? .32 : 1), now: true });   // 10/28 — 줄에 걸면 다음 누름에 엉뚱한 때 났다(sfx.js playNow)
    if (playing?.s) playing.s.playbackRate.value = 1;
  }
  async function transition(from, to, kind, onCut = () => {}) {
    await visible();
    const returning = kind === "return", between = kind === "bridge", duration = between ? 1 : returning ? 1.25 : 1.5;
    effect(kind, duration);
    if (reduced.matches) { await onCut(); return; }
    let cut = kind === "entry", began = performance.now(), pausedBefore = hiddenTime, lastDraw = -1000;
    if (cut) await onCut();
    mist.draw(from, returning ? from : to, 0, returning, between); canvas.classList.add("on");
    try {
      await new Promise((resolve, reject) => {
        const draw = async now => {
          if (hidden) { requestAnimationFrame(draw); return; }
          const elapsed = now - began - (hiddenTime - pausedBefore);
          const p = Math.min(1, elapsed / (duration * 1000));
          try {
            if (!cut && p >= .4) { cut = true; const waiting = performance.now(); await onCut(); began += performance.now() - waiting; }
            if (now - lastDraw >= 1000 / 24 || p === 1) { lastDraw = now; mist.draw(from, cut ? to : from, p, returning, between); }
            if (p < 1) requestAnimationFrame(draw); else resolve();
          } catch (error) { reject(error); }
        };
        requestAnimationFrame(draw);
      });
    } finally { canvas.classList.remove("on"); }
  }
  function discard(v) {
    if (!v) return; v.pause(); held.delete(v); v.removeAttribute("src"); v.load(); v.remove();
    for (const [key, item] of videos) if (item === v) videos.delete(key);
  }
  function clear() {
    active = false; index = -1; current = null;
    if (layer) { layer.classList.remove("on"); canvas.classList.remove("on"); }
    [...videos.values()].forEach(discard);
  }
  function setup(config, host, sfx) {
    stage = host; sound = sfx; questions = config.flow.questions || [];
    if (!questions.length) { prepared = Promise.resolve(false); return; }
    const style = document.createElement("style");
    // 10/8 — 자막(#sub)은 회상 막(1)과 유료 결과 막(.paid 7) 위에 보이게 8(play.html .sub 와 같은 값 — 유료 대사 자막)
    style.textContent = ".question-memory{position:absolute;inset:0;z-index:1;opacity:0;pointer-events:none;overflow:hidden}.question-memory.on{opacity:1}.question-memory video,.question-memory canvas{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0}.question-memory video.on{opacity:1}.question-memory canvas{z-index:2}.question-memory canvas.on{opacity:1}#stage>#sub{z-index:8}";
    document.head.appendChild(style); layer = document.createElement("div"); layer.className = "question-memory"; layer.setAttribute("aria-hidden", "true");
    canvas = document.createElement("canvas"); layer.appendChild(canvas); stage.insertBefore(layer, stage.querySelector(".shade"));
    // 10/8 — 회상 영상 칸을 질문마다 처음부터 둔다(10/20 — 미리 만든 칸 slots 를 쓴다). 손님이 누를 때(unlock) 모두 풀어 둔다 — 예전엔 장면마다 나중에 새 칸을 만들어,
    //   아이폰 저전력 모드 · 앱 안 브라우저처럼 누르지 않은 영상 재생을 막는 곳에서 틀지 못했다
    mist = renderer(); questions.forEach(q => video(q.q));
    // 목록은 다듬은 표만 쓴다. 토스에서는 표 받기가 늦어도 그 표가 끝날 때까지 기다리고, 표가 없으면 옛 목록으로 받지 않는다.
    prepare = () => Promise.resolve(window.BGVIDEOOPT_READY).then(() => {
      const map = window.BGVIDEOOPT?.memoryMapUrl;
      if (typeof map !== "string" || !map) throw Error("회상 장면 누락");
      return resource(map, "high");
    }).then(blob => blob.text()).then(JSON.parse).then(manifest => {
      scenes = manifest[String(config.no).padStart(2, "0")];
      if (!scenes || questions.some(q => !scenes[q.q])) throw Error("회상 장면 누락");
      if (woken) warm();
      return mist.ready.then(() => true);
    });
    prepared = prepare(); prepared.catch(() => {});
  }
  // 누른 이 순간에 회상 영상 칸을 모두 풀어 둔다(무비 대사 영상 unlock 과 같은 방법 — 누름 안에서 한 번 틀었다 멈춘다).
  //   10/20 — 무비가 손님의 실제 누름 안에서만 부른다(09-boot 누름풀기 · 동의 창 bg:agreement-prepare). wake 는 누름 밖에서도 불려(동의 창 · 일찍 누른 길) 거기서 풀면 막혔다
  function unlock() { [...videos.values(), ...slots].forEach(v => { const p = v.play(); if (p) p.catch(() => {}); v.pause(); }); }   // 아직 질문에 안 쓴 미리 만든 칸(slots)도 — 자료가 오기 전의 누름
  function wake() {
    if (!questions.length) return;
    woken = true; warm();
    sound?.load({ "memory-entry": [FX + "shared-entry-v9.wav"], "memory-return": [FX + "shared-return-v9.wav"], "memory-bridge": [FX + "shared-bridge-v10.wav"] });
  }
  // 회상 장면을 못 받거나 못 틀면 — 장면을 걷고(active 끔) 무비는 그대로 이어 간다(runFree 는 next 가 줄을 안 틀면 직접 튼다)
  function skip(error) { console.warn("회상 장면 없이 이어 감", error); clear(); }
  async function enter(from, prepareVoice = () => {}) {
    if (!questions.length) return false;
    try {
      await required(() => prepared, () => { prepared = prepare(); prepared.catch(() => {}); }, true);
      index = 0; const next = video(questions[0].q);
      await required(() => moving(next), () => next.load(), true);
      return await required(async () => {
        current = next; active = true; prepareVoice(); current.classList.add("on");
        layer.classList.add("on"); await transition(from, next, "entry"); return true;
      }, () => next.load());
    } catch (error) { skip(error); return false; }
  }
  async function next(key, start = () => {}) {
    if (!active || questions[index]?.q === key) return;
    const previous = current, target = video(key);
    try {
      await required(() => moving(target), () => target.load(), true);
      await required(async () => {
        await transition(previous, target, "bridge");
        index = questions.findIndex(q => q.q === key);
        target.classList.add("on"); previous.classList.remove("on"); current = target; discard(previous);
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        start();
        warm();
      }, () => video(key).load());
    } catch (error) { skip(error); }
  }
  // 10/20 — 돌아갈 끝인사(target)는 무대 영상이다. 받기 · 다시 걸기는 무대가 맡으므로 여기서 다시 걸거나(받기가 처음으로 돌았다) 다시 틀지(끝인사 · 효과음이 두 번) 않는다 — 못 움직이면 장면만 걷는다
  async function leave(target, start) {
    let started = false;
    const cut = async () => { started = true; start(); await moving(target); };
    if (!active) { start(); return; }
    try { await transition(current, target, "return", cut); }
    catch (error) { skip(error); if (!started) start(); return; }
    clear();
  }
  function away(value) {
    if (hidden === value) return; hidden = value;
    if (hidden) hiddenAt = performance.now(); else hiddenTime += performance.now() - hiddenAt;
    if (hidden) videos.forEach(v => { if (!v.paused) { held.add(v); v.pause(); } });
    else { held.forEach(v => v.play().catch(() => {})); held.clear(); }
  }
  document.addEventListener("visibilitychange", () => away(document.visibilityState === "hidden"));
  addEventListener("pagehide", () => away(true)); addEventListener("pageshow", () => away(document.visibilityState === "hidden"));
  return { setup, unlock, wake, enter, next, leave, get active() { return active; }, state: () => ({ active, question: questions[index]?.q || null, time: current?.currentTime || 0, paused: current?.paused ?? true, videos: videos.size }) };
})();
